import React, { FC } from "react";
import styled from "@emotion/styled";

import GoogleReCAPTCHA, {
  ReCAPTCHAProps as GoogleReCAPTCHAProps,
} from "react-google-recaptcha";

export interface ReCAPTCHAProps extends GoogleReCAPTCHAProps {
  error?: string;
}

const ReCAPTCHA: FC<ReCAPTCHAProps> = ({ error, ...props }) => (
  <ReCAPTCHAWrapper>
    <GoogleReCAPTCHA {...props} />
    {error && <ReCAPTCHAError>{error}</ReCAPTCHAError>}
  </ReCAPTCHAWrapper>
);

const ReCAPTCHAWrapper = styled.div`
  display: block;
`;

const ReCAPTCHAError = styled.span`
  display: block;
  color: #e31c79;
  margin-top: 0.1rem;
  font-family: "Clan news", sans-serif;
`;

export default ReCAPTCHA;
